import React from "react";
import LegalLayout from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout title="Privacy Policy" updated="February 6, 2026">
      <p>
        Foldora Laundry Inc. ("Foldora", "we", "us") respects your privacy. This Privacy Policy explains what personal information
        we collect when you use our laundry pickup &amp; delivery service, how we use it, and the choices you have.
      </p>
      <h2>1. Information we collect</h2>
      <ul>
        <li><strong>Account info</strong>: name, email, phone, and — for Google sign-in — your Google display name and profile picture.</li>
        <li><strong>Order info</strong>: pickup address, weight, service preferences, notes, and payment method.</li>
        <li><strong>Payment data</strong>: handled directly by Stripe and PayPal; we never store card numbers.</li>
        <li><strong>Usage data</strong>: pages visited, features used, device/browser type, and cookies for session management.</li>
      </ul>
      <h2>2. How we use it</h2>
      <ul>
        <li>To schedule pickups, process bookings, and deliver clean laundry.</li>
        <li>To send order updates, receipts, and (with consent) marketing communications.</li>
        <li>To improve the service, prevent fraud, and comply with legal obligations.</li>
      </ul>
      <h2>3. Sharing</h2>
      <p>
        We share information only with vetted service providers (couriers, payment processors, cloud hosting) that need
        it to operate the service. We never sell your personal data.
      </p>
      <h2>4. Your rights</h2>
      <p>
        You may request access, correction, or deletion of your data at any time by writing to info@foldora.ca.
        Residents of the EU/UK and California may have additional rights under GDPR / CCPA.
      </p>
      <h2>5. Security</h2>
      <p>
        We use TLS in transit, encrypted storage at rest, and role-based access controls. No system is 100% secure —
        please use a strong password.
      </p>
      <h2>6. Contact</h2>
      <p>Privacy questions: info@foldora.ca · 123 Wash Lane, Toronto, ON.</p>
    </LegalLayout>
  );
}
